<template>
  <div class="practice-clazz-detail-page">
    <TitleBar title="训练表现" back>
      <el-button type="primary" @click="viewPlan">查看计划</el-button>
    </TitleBar>
    <div class="main">
      <training-overview-info :training="training"></training-overview-info>
      <training-clazz-static-info :clazz-summary-items="clazzSummaryItems"></training-clazz-static-info>
      <list-page class="list-page" :pagination-data="pageData" :limit="query.limit">
        <el-table-column label="班级">
          <template v-slot="{ row }">
            {{ row.class_vo.note_name || row.class_vo.name }}
          </template>
        </el-table-column>

        <el-table-column label="人数">
          <template v-slot="{ row }">
            {{ row.students_count }}
          </template>
        </el-table-column>

        <el-table-column label="完成人数">
          <template v-slot="{ row }">
            {{ row.completion_count }}
          </template>
        </el-table-column>
        <el-table-column label="完成率">
          <template v-slot="{ row }">
            <span :style="service.participatedRateColor(row.completion_rate * 100)">
              {{ formatRate(row.completion_rate / 100) }}%
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="action" label="更多操作" align="center">
          <template v-slot="{ row }">
            <el-button type="text" @click="navToDetail(row.challenge_class_id)">详情</el-button>
          </template>
        </el-table-column>
      </list-page>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import { IClazzStaticSummary, ITrainingListItem } from 'kuaidong-model'
import TitleBar from '@/components/TitleBar.vue'
import { DateWrapper, UnitUtil } from 'kuaidong-lib'
import { AWinter2023 } from 'kuaidong-api'
import ListPage from '@/components/ListPage.vue'
import TrainingOverviewInfo from '@/views/special-skill/components/TrainingOverviewInfo.vue'
import TrainingClazzStaticInfo from '@/views/special-skill/components/TrainingClazzStaticInfo.vue'
import { NewCourseLiveService } from 'kuaidong-service'

@Component({
  components: {
    TitleBar,
    ListPage,
    TrainingOverviewInfo,
    TrainingClazzStaticInfo,
  },
})
export default class PracticeClazzDetailPage extends BasePage {
  @Prop({ type: Object, required: true })
  training!: ITrainingListItem

  @Prop({ type: String, required: true })
  from!: 'KNOWLEDGE' | 'SPECIAL_EXERCISE'

  query = {
    limit: 20,
  }
  staticInfo: IClazzStaticSummary | null = null
  summaryItems: IClazzStaticSummary[] = []

  get service() {
    return NewCourseLiveService
  }

  get pageData() {
    return {
      count: this.summaryItems.length,
      items: this.summaryItems,
    }
  }

  get clazzSummaryItems() {
    if (this.staticInfo === null) {
      return [
        { value: '-', title: '学生人数' },
        { value: '-', title: '已完成' },
        { value: '-', title: '未完成' },
        { value: '-', title: '完成率' },
      ]
    } else {
      return [
        { value: this.staticInfo?.students_count, title: '学生人数' },
        { value: this.staticInfo?.completion_count, title: '已完成' },
        { value: this.staticInfo?.uncompleted_count, title: '未完成' },
        { value: this.staticInfo.completion_rate, title: '完成率' },
      ]
    }
  }

  get clazzOptions() {
    return this.summaryItems.map((item) => {
      return {
        challenge_id: item.challenge_id,
        challenge_class_id: item.challenge_class_id,
        label: item.class_vo?.note_name || item.class_vo?.name,
        value: item.class_vo?.id,
      }
    })
  }

  async created() {
    this.fetchClazzStaticInfo()
    this.fetchClazzSummaryList()
  }

  async fetchClazzStaticInfo() {
    this.staticInfo = await AWinter2023.trainingClassSummary(this.training.group_id)
  }

  async fetchClazzSummaryList() {
    this.summaryItems = await AWinter2023.trainingClassSummaryList(this.training.group_id)
  }

  formatDate(dt: string) {
    return new DateWrapper(dt).showDateStrShort3
  }

  formatRate(rate: number) {
    return UnitUtil.percent(rate)
  }

  navToDetail(challengeClassId: string) {
    this.$router.push({
      name: 'exam_practice_student_list_detail',
      query: {
        training: JSON.stringify(this.training),
        clazzOptions: JSON.stringify(this.clazzOptions),
        challengeClassId,
        from: this.from,
      },
    })
  }

  viewPlan() {
    if (this.from === 'KNOWLEDGE') {
      this.$routerHelper.navToQuestionDetail(this.staticInfo?.paper_id)
    } else {
      this.$router.push({
        name: 'exam_task_detail',
        query: {
          id: this.staticInfo?.challenge_id,
        },
      })
    }
  }
}
</script>
<style lang="less">
.practice-clazz-detail-page {
  > .main {
    padding: 22px 24px;
    background: #fff;

    > .list-page {
      margin-top: 24px;
      padding: 0;
    }
  }
}
</style>
